import React, { useEffect, useState } from 'react'
import styles from './DownloadImage.module.sass'
import PreviewImage from '../../PreviewImage'
import { Package } from '../../../models/_models'
import BackgroundCarousel from '../../BackgroundCarousel'

const BackgroundPicker = ({ orderPackage = undefined, background, setBackground, foreground, initialBackground }) => {
  const [currentOrderPackage, setCurrentOrderPackage] = useState(null)
  const [backgrounds, setBackgrounds] = useState([])

  useEffect(() => {
    if (!currentOrderPackage) return

    Package
      .includes({ backgroundSet: 'backgrounds' })
      .find(currentOrderPackage.packageId)
      .then((res) => {
        if (res.data && res.data.backgroundSet && res.data.backgroundSet.backgrounds.length > 0) {
          setBackgrounds(res.data.backgroundSet.backgrounds)
        }
      })
  }, [currentOrderPackage && currentOrderPackage.id])

  useEffect(() => {
    setCurrentOrderPackage(orderPackage)
  }, [orderPackage])

  if (!currentOrderPackage) return null

  return (
    <div>
      <div className={styles.imageWrapper}>
        {!initialBackground && (
          <BackgroundCarousel
            scrollable
            useSetDefault={false}
            backgrounds={backgrounds}
            onSelection={(newBackground) => setBackground(newBackground)}
          />
        )}

        <div className={styles.previewImageWrapper}>
          <PreviewImage
            foregroundUrl={foreground.imageUrl}
            backgroundUrl={(background && background.imageUrl) || foreground.imageUrl}
            accessCodeOnly={false}
            noTouchAction
          />
        </div>
      </div>

    </div>
  );
}

export default BackgroundPicker
